import React from 'react';
import classnames from 'classnames';
import { silkscreenColor } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const SilkscreenColor = (props) => {
  const name = 'silkscreen_color';

  const {
    onChangeParameter,
    label,
    required,
    options,
    tooltip,
    parameters,
    groupName,
    className,
    disabled,
    locked,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      className={classnames('silkscreen-sides', className)}
      disabled={disabled}
      locked={locked} />
  );
};

SilkscreenColor.defaultProps = {
  label: Spree.translations.parameters.silkscreen_color,
  options: silkscreenColor,
  name: 'silkscreen_color',
  tooltip: Spree.helpForParameters.silkscreen_color,
};

export default SilkscreenColor;
